import { useEconomicCalendarSectionContent } from './useEconomicCalendarSectionContent';
import { parseEconomicCalendarHeroContent } from '../utils/economicCalendarContent';

export const useEconomicCalendarHeroContent = () =>
  useEconomicCalendarSectionContent(parseEconomicCalendarHeroContent);
